/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Debug from "debug";
import { getBooleanWithDefault as getBooleanFromLocalStorage } from "./../util/local-storage";

const debug = Debug("store-settings");

/**
 * @name Settings
 *
 */

const MUTATIONS = {
  SET_NOTIFICATIONS_VISIBILITY: "setNotificationsVisibility",
  SET_WEBP: "setWebp"
};

const STATE = {
  NOTIFICATIONS_VISIBILITY: "notificationsVisibility",
  WEBP: "webp"
};

export default {
  namespaced: true,
  state: {
    [STATE.NOTIFICATIONS_VISIBILITY]: getBooleanFromLocalStorage(
      STATE.NOTIFICATIONS_VISIBILITY,
      true
    ),
    [STATE.WEBP]: false
  },
  getters: {
    /**
     * @memberOf Settings
     * @public
     * @type {boolean} value
     */
    notificationsVisible: state => state[STATE.NOTIFICATIONS_VISIBILITY],
    webp: state => state[STATE.WEBP]
  },
  mutations: {
    [MUTATIONS.SET_NOTIFICATIONS_VISIBILITY]: (state, visible) => {
      state.notificationsVisibility = visible;
      localStorage.setItem(
        STATE.NOTIFICATIONS_VISIBILITY,
        JSON.stringify(visible)
      );
    },
    [MUTATIONS.SET_WEBP]: (state, supported) => {
      debug(`Webp support set to ${supported}`);
      state.webp = supported;
    }
  },
  actions: {
    /**
     * @memberOf Settings
     * @public
     */
    async showNotifications({ commit }, visible) {
      commit(MUTATIONS.SET_NOTIFICATIONS_VISIBILITY, visible);
    },
    setWebpSupport({ commit }, enabled) {
      commit(MUTATIONS.SET_WEBP, enabled);
    }
  }
};
